import { render, staticRenderFns } from "./NoticeDetailDialog.vue?vue&type=template&id=36c6ad6b&scoped=true&"
import script from "./NoticeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetailDialog.vue?vue&type=style&index=0&id=36c6ad6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c6ad6b",
  null
  
)

export default component.exports